import * as React from 'react';

import { useTranslations } from '@rematter/modules/trade/i18n/useTranslations';
import { MaterialSymbol } from '@rematter/ui-web';
import { LucideCog } from 'lucide-react';

import { LoadStagedFieldProps } from '../_types';

import { useInventoryGroupStyle } from '~/modules/trade/hooks/useInventoryGroupStyle';
import { SelectCatalyticMaterialTouch } from '~/shared/components/select-fields/SelectCatalyticMaterialTouch';

export const InventoryItemCatalyticField: React.FC<LoadStagedFieldProps> = ({
  lineItem,
  inventoryItem,
  disabled,
  touchModeEnabled,
  onClick,
  onUpdateItem,
  onFocus,
  onBlur,
}) => {
  const t = useTranslations();

  const groupStyle = useInventoryGroupStyle({});

  const handleItemChange = React.useCallback(
    (itemId?: string) => {
      onUpdateItem(lineItem.id, { itemId });
    },
    [lineItem.id, onUpdateItem],
  );

  const handleTriggerItemSelect = () => onClick?.();

  const materialSymbol = (
    <MaterialSymbol
      description={inventoryItem?.mnemonic ?? undefined}
      style={groupStyle}
      className="h-[44px] w-[35px] max-w-[35px]"
      symbolIcon={<LucideCog size={16} />}
    />
  );

  return (
    <div className="@InventoryItemCatalyticField flex items-center gap-2">
      {materialSymbol}
      <SelectCatalyticMaterialTouch
        value={lineItem.itemId ?? undefined}
        onChange={handleItemChange}
        placeholder={t.loadStaged.placeholders.selectCatalyticConverter}
        onFocus={onFocus}
        onBlur={onBlur}
        isDisabled={disabled}
        variant="outlined"
        onTriggerClick={touchModeEnabled ? handleTriggerItemSelect : undefined}
      />
    </div>
  );
};
